export function objectToHTML(node) {
    if (!node) {
      return ""
    }
    if (Array.isArray(node)) {
      return node.map((item) => objectToHTML(item)).join("")
    }
    if (node.type === "text") {
      let contentHTML = node.text || ""
      if (node.marks) {
        node.marks.forEach((mark) => {
          if (mark.type === "link") {
            const href = mark.attrs.href
            contentHTML = `[${contentHTML}](${href})`
          } else if (mark.type === "bold") {
            contentHTML = `**${contentHTML}**`
          } else if (mark.type === "italic") {
            contentHTML = `*${contentHTML}*`
          }
        })
      }
      return contentHTML
    }
    return ""
  }